export class CardCss {
    mainCard?: string;
    image?: string;
    body?: string;
    title?: string;
    summary?: string;
    author?: string;
    footer?: string;
  
    constructor() {
      this.mainCard = 'card-bg class-link';
      this.body = 'w-full h-[225px] flex flex-col';
      this.image = 'card-imagebg';
      this.title = 'card-title';
      this.summary = 'card-summary';
      this.author = 'card-author';
      this.footer = 'text-xs pb-4 px-5 mt-auto';
    }
  }